import { ContentfulLinkedReference } from "@tiicker/util/lib/contentful/types";
import Link from "next/link";
import React from "react";
import styles from "./FileCard.module.scss";
import ChevronRightIcon from "public/icons/chevron-right.svg";
import DownArrow from "../../../public/icons/small-down-arrow.svg";
import TiiDisplay from "components/TiiDisplay/TiiDisplay";

type Props = {
  title: string;
  description: string;
  url: string;
  tickerSymbol: string;
};

const FileCard = (props: Props) => {
  return (
    <div className={styles.card}>
      <div>
        <TiiDisplay size="thin-xs" text={props.tickerSymbol} type="dark" />
        <p className={styles.title}>{props.title}</p>
      </div>
      <a>
        <p className={styles.description}>
          {props.description !== "" ? props.description : "Download"}{" "}
          <ChevronRightIcon />
        </p>
      </a>
    </div>
  );
};

export default FileCard;
